import React, { PureComponent } from 'react'
import './index.css'

class Input extends PureComponent {
  render() {
    return (
      <input
        type="text"
        { ...this.props } />
    )
  }
}

export default Input



// WEBPACK FOOTER //
// ./src/components/Input/index.js